if(BSS_B2B) {
  //CP
  window.addEventListener("cart_changed", () => {
    setTimeout(() => {
      let storeData = JSON.parse($("#bss-b2b-store-data").html());
      BSS_B2B.cart.fixer(storeData, null, false);
    }, 500);
  });

  setTimeout(() =>{
    const targetMiniCart = document.querySelector(".cart-drawer-container");
    if (targetMiniCart) {
      const mutationObserver = new MutationObserver((recordList, observe) => {
          BSS_B2B.cart.fixer(JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML),false,false);
          setTimeout(() =>{
            BSS_B2B.handleCartCheckoutBtn(JSON.parse($("#bss-b2b-store-data").html()));
          }, 1500)
      });
      mutationObserver.observe(targetMiniCart, { attributes: true });
    }
  }, 500)

   //fix spam checkout 
    setTimeout(() =>{
      function handleButtonClick(e) {
        e.preventDefault();
        const $button = $(this);
        let oldText = $(this).text();
        $button.css({'pointer-events': 'none', 'opacity': '0.6'});
        $button.text("Loading ...");
        setTimeout(() =>{
          $button.css({'pointer-events': 'unset', 'opacity': '1'})
            $button.text(oldText);
        }, 2000);
      }
     
     $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
    }, 1000)
}
